import { AccountantService } from "./../../../main/accountant/accountant.service";
import { WorkspacesService } from "./../../../main/accountant/workspaces.service";
import { Component, Input, OnInit } from "@angular/core";
import { FoldersComponent } from "../folders/folders.component";
import { AppsAndResourcesComponent } from "../apps-and-resources/apps-and-resources.component";
import { DfClientTasksComponent } from "../df-client-tasks/df-client-tasks.component";
import { InviteMessageComponent } from "../invite-message/invite-message.component";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: "app-df-workspace",
    templateUrl: "./df-workspace.component.html",
    styleUrls: [
        "./df-workspace.component.scss",
        "../../../main/accountant/tracked-items-dashboard.component.css",
        "../../../files-manager/files-manager.component.scss",
        "../../templates.component.scss",
    ],
    imports: [
        NgClass,
        NgIf,
        InviteMessageComponent,
        DfClientTasksComponent,
        AppsAndResourcesComponent,
        FoldersComponent,
    ]
})
export class DfWorkspaceComponent implements OnInit {
  activeTab: string = "inviteMessage";
  inviteMessage;
  clientTasks;
  appsAndResources;
  folders;
  clientData;
  contactData;

  @Input() defaultEmail: string;
  @Input() user;
  @Input() data;
  @Input() company;
  constructor(
    private workspaceService: WorkspacesService,
    private accountantService: AccountantService
  ) {}

  ngOnInit(): void {
    this.inviteMessage = true;
  }

  switchTabs(tab: string) {
    console.log("the tab", tab);
    this.inviteMessage = false;
    this.clientTasks = false;
    this.appsAndResources = false;
    this.folders = false;
    this.clientData = false;
    this.contactData = false;
    this.activeTab = tab;

    tab === "inviteMessage" ? (this.inviteMessage = true) : "";
    tab === "clientTasks" ? (this.clientTasks = true) : "";
    tab === "appsAndResources" ? (this.appsAndResources = true) : "";
    tab === "folders" ? (this.folders = true) : "";
    tab === "clientData" ? (this.clientData = true) : "";
    tab === "contactData" ? (this.contactData = true) : "";
  }
}
